import type { FC, ReactNode } from 'react'

import { Navigation, Phone } from 'lucide-react'
import { directionsUrl, whatsappUrl } from '@/lib/business'
import { WhatsAppIcon } from '@/components/generals/icons'
import { contact } from '@/constants/site'

const itemClass = 'flex h-full flex-col items-center justify-center gap-1 text-[0.7rem] font-medium tracking-wide text-ivory/90 transition-colors active:bg-white/5 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-gold'

// Always-visible contact bar for phones: call, WhatsApp and directions in one tap.
export const MobileActionBar: FC = (): ReactNode => {
    return (
        <nav
            aria-label='Quick contact'
            className='fixed inset-x-0 bottom-0 z-40 border-t border-gold/25 bg-plum-deep/95 pb-[env(safe-area-inset-bottom)] shadow-[0_-10px_30px_-12px_rgba(0,0,0,0.5)] backdrop-blur-md md:hidden'
        >
            <ul className='grid h-16 grid-cols-3 items-stretch'>
                <li>
                    <a href={contact.phoneHref} className={itemClass}>
                        <Phone className='size-5 text-gold-light' aria-hidden='true' />
                        Call
                    </a>
                </li>

                <li className='flex items-center justify-center px-2'>
                    <a
                        href={whatsappUrl()}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='gold-gradient flex h-11 w-full max-w-[9.5rem] items-center justify-center gap-2 rounded-full text-sm font-semibold text-plum-deep shadow-md shadow-black/30 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold'
                    >
                        <WhatsAppIcon className='size-5' />
                        WhatsApp
                    </a>
                </li>

                <li>
                    <a href={directionsUrl()} target='_blank' rel='noopener noreferrer' className={itemClass}>
                        <Navigation className='size-5 text-gold-light' aria-hidden='true' />
                        Directions
                    </a>
                </li>
            </ul>
        </nav>
    )
}
